import * as Sentry from "@sentry/react";
import {useEffect} from "react";

const ZENDESK_OFFSET_STYLE_ID = "zendesk-widget-offset";

export const useZendeskWidgetOffset = (bottomOffset: string) => {
  useEffect(() => {
    const setOffset = (offset: string) => {
      try {
        let style = document.getElementById(ZENDESK_OFFSET_STYLE_ID);

        if (offset === "0px" || offset === "0") {
          style?.remove();
          return;
        }

        if (!style) {
          style = document.createElement("style");
          style.id = ZENDESK_OFFSET_STYLE_ID;
          document.head.appendChild(style);
        }

        style.textContent = `
          #launcher { bottom: ${offset} !important; }
          iframe[data-product="web_widget"] { bottom: ${offset} !important; }
        `;
      } catch (e) {
        Sentry.captureException(e, {data: "Failed to set Zendesk widget offset"});
      }
    };

    setOffset(bottomOffset);
    return () => setOffset("0px");
  }, [bottomOffset]);
};
